import React, { useEffect, useState } from "react";
import styles from './EvaluationResponse.module.scss';
import Tooltip from "../tooltip/Tooltip";
import useDeviceType from "../../hooks/useDeviceType";
import PropTypes from "prop-types";

const EvaluationResponse = ({
  options,
  selected,
  onChange
}) => {
  const [tootTipPosition, setTooltipPosition] = useState('left');
  const { isDesktopAndAbove } = useDeviceType();
  
  useEffect(() => {
    setTooltipPosition(isDesktopAndAbove ? 'right' : 'left');
  }, [isDesktopAndAbove])

  return (
    <div className={styles.options}>
      {options.map((option) => (
        <div
          className={
            `${styles.option}
             ${option.point ? styles[`option-${option.point}`] ?? '' : ''}
             ${selected === option.id ? styles.selected : ''}`
          }
          key={option.name}
        >
          <div className={styles.number}>{option.point === 0 ? 'NA' : option.point}</div>
          <div 
            className={styles.label}
            onClick={() => onChange(option.id)}
          >
            {option.name}
          </div>  
          <Tooltip content={option.description} position={tootTipPosition} />
        </div>
      ))}
    </div>
  );
};

EvaluationResponse.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      point: PropTypes.number.isRequired,
      description: PropTypes.string
    })
  ),
  selected: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default EvaluationResponse;